export default "__VITE_ASSET__DQ$1DxIj__"